import { useCallback } from "react";
import { useLazyQuery } from "@apollo/client";
import {
  FINDING_FILTER_DEPENDENCIES,
  type DependencySet,
  type FilterDependenciesQueryResponse,
} from "../../../Findings/FindingsFilters/FindingsFilterApi";

export interface UseFilterDependenciesReturnValue {
  check: (filterId: string) => void;
  loading: boolean;
  called: boolean;
  dependencies?: DependencySet | null;
  error?: unknown;
}

export const useFilterDependencies = (): UseFilterDependenciesReturnValue => {
  const [run, { data, loading, called, error }] =
    useLazyQuery<FilterDependenciesQueryResponse>(FINDING_FILTER_DEPENDENCIES, {
      fetchPolicy: "network-only",
    });

  const check = useCallback(
    (filterId: string) => {
      run({ variables: { id: filterId } });
    },
    [run]
  );

  return {
    check,
    loading,
    called,
    dependencies: data?.finding_filter_dependencies,
    error,
  };
};
